module.exports = __webpack_public_path__ + "static/media/user-icon-inactive.f0ad6db4.svg";